import React, {useContext, useEffect} from "react";
import{useLocation} from 'react-router-dom';
import Header from "../components/header/Header";
import PageTemplate from "../components/PageTemplate";
import HomeBody from "../components/home/HomeBody";
import {GlobalContext} from "../context/GlobalState";
import users from "../services/api/users";
import {BuildContext} from "../context/BuildSpotlightState";

const Home = () => {
  const {userData, setRoles} = useContext(GlobalContext);
  const {clear} = useContext(BuildContext);
  const firstName = userData.firstName;
  const query = new URLSearchParams(useLocation().search);
  const coupon = query.get('coupon');

  const updateRoles = async () => {
    const {data: roles} = await users.getRoles();

    setRoles(roles);
  };

  useEffect(() => {
    updateRoles();
    clear();
  }, []);

  if (coupon) {
    sessionStorage.setItem('coupon', coupon);
  }

  return (
    <PageTemplate
      title='Home'
      mobileHeader={<Header />}
      sidebarTitle={`Hey, ${firstName}`}
      sidebarSubtitle='Create or view your spotlights here.'
      centered
    >
      <HomeBody />
    </PageTemplate>
  );
};

export default Home;
